module.exports = __webpack_public_path__ + "aa1bb46c4431bb7cf8d86c938a6353fc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-16.png
// module id = 2032
// module chunks = 0